exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-navigator__menu[data-v-1cf0cc90]{height:100%}.image-navigator__menu .image-navigator__thumbnail[data-v-1cf0cc90]{vertical-align:middle;margin-right:5px;width:24px;height:24px;text-align:center;font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cf0cc90","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/image-filter/image-navigator/image-navigator.vue
// module id = 203
// module chunks = 0